<!--
 © Copyright 2026 Daikin Industries, Ltd. All rights reserved.

 This software is the proprietary information of Daikin Industries, Ltd.
 By using this software, you agree to the following terms:

 1. You are granted a revocable non-exclusive, non-transferable license to use this software.
 2. You agree not to modify, distribute, or create derivative works based on this software.
 3. Unauthorized copying, distribution, or use of any portion of this software is strictly prohibited.
 4. This software is protected by copyright laws and international treaties.
 5. Any violation of these terms will result in the termination of your license and may result in legal action.
 6. This is Daikin's proprietary software and may not be used in an unauthorized manner or without express authorization from Daikin.
-->

<div class="api-explorer">
  <!-- Header Section -->
  <!-- <div class="explorer-header">
    <h2>API Explorer</h2>
    <p class="explorer-subtitle">Discover APIs available through the API Mesh</p>
  </div> -->

  <!-- Search Section -->
  <div class="search-section">
    <div class="search-container">
      <input
        type="text"
        class="search-input"
        placeholder="Search APIs by name, description, application..."
        [(ngModel)]="searchTerm"
        (input)="onSearch()"
      >
      <button
        *ngIf="searchTerm"
        class="clear-search-btn"
        (click)="clearSearch()"
        title="Clear search"
      >
        ✕
      </button>
    </div>
    <div class="search-stats" *ngIf="!loading">
      Showing {{ filteredOperations.length }} of {{ apiOperations.length }} operations
    </div>
  </div>

  <!-- Loading State -->
  <div *ngIf="loading" class="loading-state">
    <div class="loading-spinner"></div>
    <p>Loading API operations...</p>
  </div>

  <!-- Error State -->
  <div *ngIf="error" class="error-state">
    <div class="error-icon">⚠️</div>
    <h3>Failed to Load APIs</h3>
    <p>{{ error }}</p>
    <button class="retry-btn" (click)="retry()">Retry</button>
  </div>

  <!-- API Operations List -->
  <div *ngIf="!loading && !error" class="operations-container">
    <!-- No Results -->
    <div *ngIf="filteredOperations.length === 0 && apiOperations.length > 0" class="no-results">
      <div class="no-results-icon">🔍</div>
      <h3>No operations found</h3>
      <p>Try adjusting your search term or <button class="link-btn" (click)="clearSearch()">clear the search</button></p>
    </div>

    <!-- Operations Grid -->
    <div *ngIf="filteredOperations.length > 0" class="operations-grid">
      <div *ngFor="let operation of filteredOperations" class="operation-card">
        <div class="operation-header">
          <div class="operation-title">
            <h3>{{ operation.displayName }}</h3>
            <span class="operation-method" [class]="getMethodClass(operation.method)">
              {{ operation.method.toUpperCase() }}
            </span>
          </div>
        </div>

        <div class="operation-body">
          <div class="operation-description" *ngIf="operation.description">
            {{ operation.description }}
          </div>

          <div class="operation-properties">
            <div class="property-row">
              <span class="property-label">Application:</span>
              <span class="property-value">{{ operation.applicationName }}</span>
            </div>

            <div class="property-row">
              <span class="property-label">Path:</span>
              <span class="property-value"><code>{{ operation.path }}</code></span>
            </div>

            <div class="property-row">
              <span class="property-label">Parameters:</span>
              <span class="property-value">
                <div class="parameters-list" *ngIf="operation.parameters && operation.parameters.length > 0">
                  <span *ngFor="let param of operation.parameters" class="parameter-tag" [class.required]="param.required">
                    {{ param.name }}
                  </span>
                </div>
                <div class="parameters-list" *ngIf="operation.parameters == undefined || operation.parameters.length === 0">
                  <span>-</span>
                </div>
              </span>
            </div>

            <div class="property-row">
              <span class="property-label">Version:</span>
              <span class="property-value">{{ operation.version }}</span>
            </div>
          </div>
        </div>

        <div class="operation-actions">
          <button class="send-request-btn" (click)="sendRequest(operation)">
            Send Request
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
